import MenuBookIcon from "@mui/icons-material/MenuBook";

import Offices from "./Create";
import { OFFICES } from "../../../utils/constants";

export const resources = {
  isMenu: true,
  icon: <MenuBookIcon />,
  name: OFFICES,
  title: "Офиси на Бг Пощи",
  list: <Offices />,
  permission: "offices",
};
